import React from 'react';
import '../css/Slider.css';
import { Link } from 'react-router-dom';

import ad1 from '../assets/add1.jpg';
import ad2 from '../assets/add2.jpg';
import ad3 from '../assets/add3.jpg';

const SliderSkeleton = () => {
    const fallbackSlides = [
        {
            id: 1,
            title: 'Advertisement 1',
            description: 'Discover exciting offers and featured content prepared for you.',
            image: ad1,
            cta: 'Explore Now',
            link: '/events'
        },
        {
            id: 2,
            title: 'Advertisement 2',
            description: 'Stay updated with the latest promotions, events, and announcements.',
            image: ad2,
            cta: 'View Details',
            link: '/events'
        },
        {
            id: 3,
            title: 'Advertisement 3',
            description: 'Check out more opportunities and engaging experiences today.',
            image: ad3,
            cta: 'Learn More',
            link: '/events'
        }
    ];

    return (
        <div className="slider flex-wrap col-lg-8">
            <div className="slides-container">
                {fallbackSlides.map((slide, index) => (
                    <div
                        key={slide.id}
                        className={`slide ${index === 0 ? 'large' : 'small'}`}
                    >
                        <Link to={slide.link}>
                            <img src={slide.image} alt={slide.title} />
                        </Link>

                        <div className="caption">
                            <Link to={slide.link}>
                                <h3>{slide.title}</h3>
                            </Link>

                            <p>{slide.description}</p>

                            <Link to={slide.link} className="slider-cta-btn">
                                {slide.cta}
                            </Link>
                        </div>
                    </div>
                ))}
            </div>

            <div className='w-100 d-flex gap-2 p-2 justify-content-center'>
                <button className="prev" disabled>
                    &#10094;
                </button>
                <button className="next" disabled>
                    &#10095;
                </button>
            </div>
        </div>
    );
};

export default SliderSkeleton;